import { css } from '@emotion/react';

export const switchButton = css`
  position: absolute;
  top: 24px;
  right: 24px;

  @media (max-width: 720px) {
    top: 16px;
    right: 16px;
  }
`;
